export default "__VITE_ASSET__BsoNvqy7__"